import React from "react";
import { useConnection } from "../context/ConnectionContext";
import { Loader2 } from "lucide-react";

interface ConnectionWrapperProps {
  children: React.ReactNode;
}

const ConnectionWrapper: React.FC<ConnectionWrapperProps> = ({ children }) => {
  const { isConnected } = useConnection();

  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <>
      {!isConnected && (
        <div className="block top-0 w-full bg-orange-500 text-white text-center py-1 z-50 shadow-md">
          <p className="text-sm font-medium flex items-center justify-center">
            <Loader2 className="animate-spin -ml-1 mr-1 h-4 w-4 text-white" />
            You are offline. Please check your internet connection and
            <button
              onClick={handleRetry}
              className="ml-1 underline font-semibold hover:text-white/90 focus:outline-none"
            >
              retry
            </button>
            .
          </p>
        </div>
      )}
      <div
        className={`h-full ${!isConnected ? "opacity-60" : ""}`}
        style={{ pointerEvents: !isConnected ? "none" : "auto" }}
      >
        {children}
      </div>
    </>
  );
};

export default ConnectionWrapper;
